export const householdMilestoneTrackerTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined && categoryid !== undefined) {
		if (categoryid.indexOf('household_milestone.py') !== -1) {
			if (desyncdata.indexOf('AttributeError: \'NoneType\' object has no attribute \'household_milestone_tracker\'') !== -1) {
				return {
					type: 'householdMilestoneTrackerTest',
					color: 'Goldenrod',
					title: 'Sim Missing Household Error',
					text: 'Potentially base game issue with a Sim missing their household.',
					description: 'The game loaded a Sim without a household and failed to assign a shared one before proceeding.<br/><br/>For the most part, you\'re safe to ignore this error.'
				}
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>287cdd59cbe309bf5bf2b33a</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-11-19 13:58:13</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.49.1020-1.200.000.373.Release</buildsignature>
        <categoryid>household_milestone.py:38</categoryid>
        <desyncid>287cdd59cbe309bf5bf2b33a</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception raised while trying to run a test event in test_events.py: (AttributeError: 'NoneType' object has no attribute 'household_milestone_tracker')
Traceback (most recent call last):
Caught and logged:
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 113, in wrapped
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 109, in finally_wrap
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 157, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 175, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 356, in c_api_client_connect
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone.py&quot;, line 547, in do_zone_spin_up
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone_spin_up_service.py&quot;, line 1299, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone_spin_up_service.py&quot;, line 227, in on_enter
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\household_manager.py&quot;, line 70, in load_households
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\household_manager.py&quot;, line 152, in _load_household_from_household_proto
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\household.py&quot;, line 1136, in load_data
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim_info.py&quot;, line 2808, in load_sim_info
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim_info.py&quot;, line 3103, in _load_sim_info
  File &quot;T:\InGame\Gameplay\Scripts\Server\distributor\fields.py&quot;, line 145, in __set__
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim_info.py&quot;, line 2171, in allow_fame
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\__init__.py&quot;, line 459, in exported_func
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\statistic_component.py&quot;, line 960, in lock_statistic
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\ranked_statistic.py&quot;, line 938, in on_lock
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\continuous_statistic.py&quot;, line 992, in on_lock
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\ranked_statistic.py&quot;, line 708, in set_value
  File &quot;T:\InGame\Gameplay\Scripts\Server\event_testing\event_manager_service.py&quot;, line 256, in process_event
  File &quot;T:\InGame\Gameplay\Scripts\Server\event_testing\event_manager_service.py&quot;, line 365, in _process_test_event
  File &quot;T:\InGame\Gameplay\Scripts\Server\event_testing\event_manager_service.py&quot;, line 363, in _process_test_event
  File &quot;T:\InGame\Gameplay\Scripts\Server\household_milestones\household_milestone.py&quot;, line 38, in handle_event
AttributeError: 'NoneType' object has no attribute 'household_milestone_tracker'
rtim=0</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/basegame/householdMilestoneTrackerTest.js